const newRadOneRouter = [
  {
    path: '/informationConfirmation',
    name: 'InformationConfirmation',
    component: () => import('@/views/wxapp/rad/newRadOne/informationConfirmation.vue'),
    meta: {
      title: '房屋信息确认'
    }
  },
  {
    path: '/successPage',
    name: 'SuccessPage',
    component: () => import('@/views/wxapp/rad/newRadOne/successPage.vue'),
    meta: {
      title: '提交成功'
    }
  },
  {
    path: '/resultPage',
    name: 'ResultPage',
    component: () => import('@/views/wxapp/rad/newRadOne/resultPage.vue'),
    meta: {
      title: 'RAD需求评估结果'
    }
  }
]
export default newRadOneRouter
